import { languageConstants } from '../constants/languageConstants';

export const update = (language, code) => {
	return {
		type: languageConstants.LANGUAGE_UPDATE,
		language,
		code
	};
};
